export default __webpack_public_path__ + "static/media/c.15dd0d74.png";